<div>
    <button *ngIf="hasPermissions('manage_training')" style="margin: 15px" class="floatR marginB" nz-button nzType="primary" nzShape="circle" (click)="showModal(false)">
        <span nz-icon nzType="plus" nzTheme="outline"></span>
    </button>


    <div style="padding-top: 75px;">
      <nz-collapse>
        <ng-container *ngFor="let panel of panels">
          <nz-collapse-panel [nzHeader]="panel.name" [nzActive]="panel.active" [nzDisabled]="panel.disabled">

            <nz-table #trainingTable [nzData]="panel.training" [nzShowPagination]="false">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of trainingTable.data">
                  <td>{{data.crm_id}}</td>
                  <td>{{data.name}}</td>
                  <td>
                    <button *ngIf="hasPermissions('manage_distributors')" nz-button nzType="primary" (click)="showModal(data)">
                      Edit
                    </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </nz-collapse-panel>
        </ng-container>
      </nz-collapse>
    </div>
</div>

  <nz-modal [(nzVisible)]="isModalVisible" [nzFooter]="null" nzTitle="Training" [nzClosable]="false" [nzMaskClosable]="false"  nzCentered>
      <ng-container *nzModalContent>
        <nz-spin [nzSpinning]="isLoading">
          <form [formGroup]="trainingForm">

            <nz-form-item>
              <nz-form-label nzRequired>Type</nz-form-label>
              <nz-select nzAllowClear formControlName="type"  nzPlaceHolder="Select Folder or File" (ngModelChange)="onTypeChange($event)">
                <nz-option nzValue="folder" nzLabel="Folder"></nz-option>
                <nz-option nzValue="file" nzLabel="File"></nz-option>
              </nz-select>
            </nz-form-item>

            <nz-form-item *ngIf="trainingForm.get('type')?.value">
              <nz-form-label nzRequired>Name</nz-form-label>
                <input nz-input formControlName="name"/>
            </nz-form-item>

            <nz-form-item *ngIf="trainingForm.get('type')?.value == 'file'">
              <nz-form-label nzRequired>Training Link</nz-form-label>
                <input nz-input formControlName="link"/>
            </nz-form-item>

            <nz-form-item *ngIf="trainingForm.get('type')?.value == 'file'">
              <nz-form-label nzRequired>Folder</nz-form-label>
              <nz-select nzAllowClear formControlName="folder"  nzPlaceHolder="Select folder">
                <nz-option *ngFor="let f of folders" [nzValue]="f.id" [nzLabel]="f.name"></nz-option>
              </nz-select>
            </nz-form-item>

            <nz-form-item *ngIf="trainingForm.get('type')?.value == 'file'">
              <nz-form-label>Attach Quiz</nz-form-label>
              <nz-select nzAllowClear formControlName="quiz"  nzPlaceHolder="Select quiz">
                <nz-option *ngFor="let q of quizzes" [nzValue]="q.id" [nzLabel]="q.name"></nz-option>
              </nz-select>
            </nz-form-item>
              
          </form>

          <div class="buttonDiv">
            <button [disabled]="trainingForm.invalid" nz-button nzType="primary" (click)="handleOk()">Save</button>
            <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
          </div>

      </nz-spin>
    </ng-container>
  </nz-modal>
